import { jsx as a } from "react/jsx-runtime";
import { createRoot as i } from "react-dom/client";
import { AtticusModal as f } from "./index.js";
const y = 300, h = (n, l = !1) => {
  const t = document.createElement("div");
  document.body.appendChild(t);
  const o = { current: null };
  let r = !1;
  const c = i(t), d = () => {
    r && o.current ? o.current.openModal() : setTimeout(() => d(), 0);
  }, s = () => {
    r && o.current && o.current.closeModal();
  }, u = () => {
    if (o.current)
      o.current.closeModal(), setTimeout(() => {
        try {
          c.unmount(), document.body.contains(t) && document.body.removeChild(t);
        } catch (e) {
          console.error("Error destroying modal:", e);
        }
      }, y);
    else
      try {
        c.unmount(), document.body.contains(t) && document.body.removeChild(t);
      } catch (e) {
        console.error("Error destroying modal:", e);
      }
  }, m = {
    ...n,
    defaultOpen: l,
    ref: (e) => {
      e && (o.current = e, r = !0);
    },
    onClose: () => {
      var e;
      (e = n.onClose) == null || e.call(n);
    }
  };
  return c.render(/* @__PURE__ */ a(f, { ...m })), { open: d, close: s, destroy: u };
};
export {
  h as createAtticusModal
};
